import React, { useState } from "react";
import { Col, FormGroup, Row, Card, Table, Alert } from "reactstrap";
import { InspectionAmount } from "../../../store/Utility/Utility";
import Modal from "react-bootstrap/Modal";

import truck from '../../../assets/images/icon/truck.png';
import motorbike from '../../../assets/images/icon/motorbike.png';
import van from '../../../assets/images/icon/van.png';
import car from '../../../assets/images/icon/car.png';

export function VehicleTypeStep({ vehicleType, isCarfaxReportRequested, updateFields }) {
    const [selectedVehicle, setSelectedVehicle] = useState(vehicleType)
    const [isCarfaxChecked, setCarfaxCheck] = useState(isCarfaxReportRequested);
    const [showPackageInfo, setShowPackageInfo] = useState(false);

    const onClickHandler = (value) => {
        setSelectedVehicle(value);
        updateFields({ vehicleType: value });
    }

    const checkHandler = (event) => {
        setCarfaxCheck(!isCarfaxChecked);
        updateFields({ isCarfaxReportRequested: !isCarfaxChecked });
    }

    const oShowPackagePopup = () => {

    }

    const highlightedStyle = {
        backgroundColor: "#d0faec"
    }

    const cardClass = 'card';
    const borderlessCardClass = "card border-0";

    const dividerClass = "d-flex justify-content-center border-bottom border-light pb-3 mb-3";
    const higlightedDividerClass = "d-flex justify-content-center border-bottom border-white pb-3 mb-3"

    const textPrimaryClass = "h5 text-uppercase text-primary";
    const textDarkClass = "h5 text-uppercase text-dark";

    const borderStye = "1px solid #d2d2d2";
    const borderHoverStyle = "1px solid #ffffff"

    return (
        <>
            {<Modal show={showPackageInfo} onHide={() => setShowPackageInfo(false)}
                size="lg"
                scrollable
                centered>
                <Modal.Header closeButton>
                    <Modal.Title>Complete Vehicle History Package</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p className="lead">
                        Get three trusted vehicle history reports to help you make a more informed buying
                        decision before purchasing a used vehicle.
                    </p>

                    <div className="row g-3 mt-2">
                        <div className="col-md-4">
                            <div className="card mb-3" style={{ maxWidth: "18rem" }}>
                                <div className="card-header"><strong>CARFAX</strong></div>
                                <div className="card-body">
                                    <p className="card-text mb-0">
                                        One of the most recognized vehicle history providers,
                                        known for extensive reported accident, title and
                                        service history records.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="card mb-3" style={{ maxWidth: "18rem" }}>
                                <div className="card-header"><strong>AutoCheck</strong></div>
                                <div className="card-body">
                                    <p className="card-text mb-0">
                                        Widely used by dealerships and automotive professionals,
                                        featuring the AutoCheck Score to help compare similar vehicles.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="card mb-3" style={{ maxWidth: "18rem" }}>
                                <div className="card-header"><strong>VINInspect</strong></div>
                                <div className="card-body">
                                    <p className="card-text mb-0">
                                        May provide additional reported records, including
                                        vehicle listing history and other available vehicle information.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <h5 className="mt-4">Why Get Three Reports?</h5>
                    <p>
                        Each provider maintains its own database and may receive information from different
                        reporting sources. Reviewing all three reports gives you access to multiple trusted
                        vehicle history databases, helping you build a more complete picture of the
                        vehicle&apos;s reported history before you buy.
                    </p>

                    <h5 className="mt-4">What You Can Discover</h5>
                    <Row>
                        <Col md={6}>
                            <ul>
                                <li>Reported accident history</li>
                                <li>Title history</li>
                                <li>Ownership history</li>
                                <li>Mileage records</li>
                                <li>Service history (when available)</li>
                            </ul>
                        </Col>
                        <Col md={6}>
                            <ul>
                                <li>Vehicle listing history (when available)</li>
                                <li>Theft records (when reported)</li>
                                <li>Salvage or rebuilt title records (when reported)</li>
                                <li>Open recalls (when available)</li>
                                <li>Other reported vehicle information</li>
                            </ul>
                        </Col>
                    </Row>
                    <hr />

                    <h5>Exclusive Package Pricing</h5>
                    <Table bordered responsive className="mt-3">
                        <thead>
                            <tr>
                                <th>Report</th>
                                <th className="text-end">Retail Price</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>CARFAX</td>
                                <td className="text-end">$49.99</td>
                            </tr>
                            <tr>
                                <td>AutoCheck</td>
                                <td className="text-end">$29.99</td>
                            </tr>
                            <tr>
                                <td>VINInspect</td>
                                <td className="text-end">$14.99</td>
                            </tr>
                            <tr className="table-secondary fw-bold">
                                <td>Total Retail Price</td>
                                <td className="text-end">$94.97</td>
                            </tr>
                        </tbody>
                    </Table>

                    <Alert className="mt-4">
                        <h5>Your Price with Inspection</h5>
                        <h2 className="fw-bold">$39.99</h2>
                        <p className="mb-0">
                            Save <strong>$54.98</strong> and receive all three trusted vehicle history
                            reports in one convenient package.
                        </p>
                    </Alert>
                    <Row>
                        <Col md={12}>
                            <p className="small text-secondary mt-3">
                                Disclaimer: Information varies by vehicle and data source. Not every report contains every
                                type of record or reported event.
                            </p>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-dark" onClick={() => setShowPackageInfo(false)}>Close</button>
                </Modal.Footer>
            </Modal>}
            <Row form>
                <Col md={12}>
                    <div className="row align-items-center">
                        <div className="col-12 col-lg-3 col-md-6 mb-4 mb-lg-0" style={{ cursor: "pointer" }} onClick={() => onClickHandler('1')}>
                            {/* <!-- Card --> */}
                            <div className={selectedVehicle == "1" ? borderlessCardClass : cardClass} style={selectedVehicle == "1" ? highlightedStyle : null}>
                                {/* <!-- Body --> */}
                                <div className="card-body py-3 px-3 text-center">
                                    {/* <!-- Badge --> */}
                                    <div className="mb-3"> <span className={selectedVehicle == "1" ? textDarkClass : textPrimaryClass}>Car / Suv</span>
                                    </div>
                                    {/* <!-- Price --> */}
                                    <div className={selectedVehicle == "1" ? higlightedDividerClass : dividerClass}>
                                        <div className="p-2 d-inline-block rounded" style={{ border: selectedVehicle == "1" ? borderHoverStyle : borderStye, backgroundColor: "#d0faec" }}>
                                            <div className="f-icon-m text-white">
                                                <img src={car} width={60} />
                                                {/* <i className="flaticon-lightbulb"></i> */}
                                            </div>
                                        </div>
                                    </div>
                                    {/* <!-- Features --> */}
                                    <ul className="list-unstyled mb-0">
                                        <li className="mb-2">${InspectionAmount.Car}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-lg-3 col-md-6  mb-4 mb-lg-0" style={{ cursor: "pointer" }} onClick={() => onClickHandler('2')}>
                            {/* <!-- Card --> */}
                            <div className={selectedVehicle == "2" ? "card border-0" : "card"} style={selectedVehicle == "2" ? highlightedStyle : null}>
                                {/* <!-- Body --> */}
                                <div className="card-body py-3 px-3 text-center">
                                    {/* <!-- Badge --> */}
                                    <div className="mb-3"> <span className={selectedVehicle == "2" ? textDarkClass : textPrimaryClass}>Motorcycle</span>
                                    </div>
                                    {/* <!-- Price --> */}
                                    <div className={selectedVehicle == "2" ? higlightedDividerClass : dividerClass}>
                                        <div className="p-2 d-inline-block rounded" style={{ border: selectedVehicle == "2" ? borderHoverStyle : borderStye, backgroundColor: "#d0faec" }}>
                                            <div className="f-icon-m text-white">
                                                <img src={motorbike} width={60} />
                                            </div>
                                        </div>
                                    </div>
                                    {/* <!-- Features --> */}
                                    <ul className="list-unstyled mb-0">
                                        <li className="mb-2">${InspectionAmount.Motorcycle}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-lg-3 col-md-6 mb-4 mb-lg-0" style={{ cursor: "pointer" }} onClick={() => onClickHandler('3')}>
                            {/* <!-- Card --> */}
                            <div className={selectedVehicle == "3" ? "card border-0" : "card"} style={selectedVehicle == "3" ? highlightedStyle : null}>
                                {/* <!-- Body --> */}
                                <div className="card-body py-3 px-3 text-center">
                                    {/* <!-- Badge --> */}
                                    <div className="mb-3"> <span className={selectedVehicle == "3" ? textDarkClass : textPrimaryClass}>Truck / Van</span>
                                    </div>
                                    {/* <!-- Price --> */}
                                    <div className={selectedVehicle == "3" ? higlightedDividerClass : dividerClass}>
                                        <div className="p-2 d-inline-block rounded" style={{ border: selectedVehicle == "3" ? borderHoverStyle : borderStye, backgroundColor: "#d0faec" }}>
                                            <div className="f-icon-m text-white">
                                                <img src={truck} width={60} />
                                            </div>
                                        </div>
                                    </div>
                                    {/* <!-- Features --> */}
                                    <ul className="list-unstyled mb-0">
                                        <li className="mb-2">${InspectionAmount.Commercial}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-lg-3 col-md-6" style={{ cursor: "pointer" }} onClick={() => onClickHandler('4')}>
                            {/* <!-- Card --> */}
                            <div className={selectedVehicle == "4" ? "card border-0" : "card"} style={selectedVehicle == "4" ? highlightedStyle : null}>
                                {/* <!-- Body --> */}
                                <div className="card-body py-3 px-3 text-center">
                                    {/* <!-- Badge --> */}
                                    <div className="mb-3"> <span className={selectedVehicle == "4" ? textDarkClass : textPrimaryClass}>RV</span>
                                    </div>
                                    {/* <!-- Price --> */}
                                    <div className={selectedVehicle == "4" ? higlightedDividerClass : dividerClass}>
                                        <div className="p-2 d-inline-block rounded" style={{ border: selectedVehicle == "4" ? borderHoverStyle : borderStye, backgroundColor: "#d0faec" }}>
                                            <div className="f-icon-m text-white">
                                                <img src={van} width={60} />
                                            </div>
                                        </div>
                                    </div>
                                    {/* <!-- Features --> */}
                                    <ul className="list-unstyled mb-0">
                                        <li className="mb-2">${InspectionAmount.RV}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                </Col>
                <Col md={12}>
                    <FormGroup>
                        <div className="form-group mb-0 mt-5">
                            <div className="form-check">
                                <input type="checkbox" className="form-check-input" id="customCheck1" checked={isCarfaxReportRequested} onChange={checkHandler} />
                                <label className="form-check-label" htmlFor="customCheck1" >Add Complete Vehicle History Package (+$39.99) </label><i className="mx-2 las la-info-circle" onClick={() => setShowPackageInfo(true)}></i>
                                <label className="text-muted" style={{ fontSize: "0.8rem" }} htmlFor="customcheck1">Don't rely on a single vehicle history report. Get CARFAX, AutoCheck & VINInspect to access three trusted vehicle history databases.</label>
                            </div>
                        </div>
                    </FormGroup>
                </Col>
            </Row >
        </>
    )
}

